import { render } from "./ShiftDetails.vue?vue&type=template&id=2f665366"
import script from "./ShiftDetails.vue?vue&type=script&lang=js"
export * from "./ShiftDetails.vue?vue&type=script&lang=js"

import "./ShiftDetails.vue?vue&type=style&index=0&id=2f665366&lang=scss"
script.render = render

export default script